"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = {};
    }
    /**
     * @inheritDoc
     */
    EventEmitter.prototype.addListener = function (eventName, callbackFunction) {
        // No listeners for this event name
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        // Register observer
        this.listeners[eventName].push(callbackFunction);
    };
    /**
     * @inheritDoc
     */
    EventEmitter.prototype.removeListener = function (eventName, callbackFunction) {
        // Has listeners for this event name
        if (!!this.listeners[eventName]) {
            // No callback
            if (callbackFunction === undefined) {
                // Remove all listeners for this event name
                this.listeners[eventName] = [];
            }
            else {
                // Remove specific observer
                var index = this.listeners[eventName].indexOf(callbackFunction);
                if (index > -1) {
                    this.listeners[eventName].splice(index, 1);
                }
            }
        }
    };
    /**
     * @inheritDoc
     */
    EventEmitter.prototype.emit = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // Has listeners for this event name
        if (!!this.listeners[eventName]) {
            // For each register observer
            this.listeners[eventName].forEach(function (callbackFunction) { return callbackFunction.apply(null, args); });
        }
    };
    /**
     * @inheritDoc
     */
    EventEmitter.prototype.getListeners = function (eventName) {
        return this.listeners[eventName] || [];
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=emitter.js.map